import Vue from 'vue'
import { MutationTree } from 'vuex'
import { Dictionary } from '@/types/general'
import Entry from '@/data/entry-model'
import { EntriesState } from './types'
import { SET_ALL_ENTRIES, SET_ENTRY, SET_MANY_ENTRIES, SET_TREE_STACK, REMOVE_ENTRY } from './constants'

const mutations: MutationTree<EntriesState> = {
    /**
     * Set all entry data
     */
    [SET_ALL_ENTRIES](state, entries: Entry[]) {
        state.allEntries = {}
        entries.forEach((entry) => {
            Vue.set(state.allEntries, entry.id!, entry)
        })
    },

    /**
     * Set data for a list of entries
     */
    [SET_MANY_ENTRIES](state, entries: Entry[]) {
        entries.forEach((entry) => {
            Vue.set(state.allEntries, entry.id!, entry)
        })
    },

    [REMOVE_ENTRY](state, entryId: string) {
        Vue.delete(state.allEntries, entryId)
    },

    /**
     * Set a single entry's data
     */
    [SET_ENTRY](state, entry: Entry) {
        Vue.set(state.allEntries, entry.id!, entry)
    },

    [SET_TREE_STACK](state, stack: string[]) {
        state.treeStack = stack
    }
}

export default mutations
